import { SignatureSummaryContent } from '~/components/organisms/SignatureSummaryContent'

export const SignatureSummary = () => <SignatureSummaryContent />
